// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2gkfK","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__HkFy6"};